import React from 'react';
import styles from '../Operations.module.css';

interface MGUPComponent extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

/**
 * MGUP - Unproductive
 * KPI information component
 */
const MGUP: MGUPComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>

      <div className={styles.sectionContent}>
        Unproductive inventory is the dollar value (quantity on hand multiplied by average cost) of inventory that has not sold in <span className={styles.underline}>over two years and with over two years of supply</span>, divided by total inventory value.<br/><br/>
        SKU-level detail can be found in your KIM Excel report, Obsolete and Overstock tabs.<br/>
        Your unproductive metric is made up of two separate components:<br/>
        <strong>Obsolete</strong> - SKUs not sold in over two years<br/>
        <strong>Overstock</strong> - SKUs with over two years of supply
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>

      <div className={styles.sectionContent}>
        Unproductive inventory is an inevitable part of retail as inventory becomes outdated, residue builds from sale bills, and when customers don&apos;t buy exactly the quantity we anticipated when that two-pallet deal shows up.<br/>
        This inventory is expensive to keep around because it absorbs labor, shelf space, and investment.<br/><br/>
        Because of this, it&apos;s critical for a store to have an ongoing process to manage its unproductive inventory; it is Level 0 because it&apos;s such a foundational retail process.<br/>
        Stores with an ongoing unproductive management process can take more inventory risks (deepening and adding new items) because if an item doesn&apos;t sell as anticipated then it will systematically be churned out and converted back into cash to be used for the next investment.
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>

      <div className={styles.sectionContent}>
        7% and lower
      </div>

      <div className={styles.sectionTitle}>
        Drill Down
      </div>

      <div className={styles.sectionContent}>
        13-month chart of history
      </div>

      <div className={styles.sectionTitle}>
        Take Action
      </div>

      <div className={styles.sectionContent}>
        See Ace Way of Retailing (AWOR) <a href="https://acenet.aceservices.com/awor/unproductive-inventory" target="_blank" rel="noopener noreferrer" className={styles.link}>Obsolete Inventory-Closeout Management</a> Setup to reduce the amount of Unproductive Inventory.
      </div>
    </div>
  );
};

MGUP.title = 'Mango Unproductive Inventory';
MGUP.actionTitle = 'Inventory Boost Tool';
MGUP.actionHyperlink = '';
export default MGUP;

